export default "__VITE_ASSET__8bb981c4__"